import { render, staticRenderFns } from "./CustomerSuccess.vue?vue&type=template&id=6b75577a&"
import script from "./CustomerSuccess.vue?vue&type=script&lang=ts&"
export * from "./CustomerSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports